import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ActiveTab } from "@/components/common/ActiveTab";
import { FilterArea, MobileSliderArea, SelectingArea } from "@/components/Search/index";
import { MobileFilterSideSheet } from "@/components/Search/MobileFilterSideSheet";
import { MobileSearchFilterItemList } from "@/components/Search/MobileSearchFilterItemList";
import { SearchDetailFilter } from "@/components/Search/SearchDetailFilter";
import { SearchFilterSelectedList } from "@/components/Search/SearchFilterSelectedList";
import { SearchResultDesc } from "@/components/Search/SearchResultDesc";
import { SOLVOOKPASS_TEXT } from "@/settings/constant";
import React, { useMemo } from "react";
import { SearchQueryKey } from "src/api/search";
import { SearchPageAdBanner } from "../Banner/AdBanner/SearchPageAdBanner";
export const SearchFilterSectionView = (param)=>{
    let { subjectTabList , filterParams , handleSubjectFilter , handleDetailFilter , handleKeywordFilter , handleSortFilter , handleResetFilter , handleSolvookPassesFilter , isCheckFilterItem , isCheckFilterCount , selectedFilterList , newFilterList , hasSelectedFilter , mobileFilterSideSheet , handleMobileSideSheet , keywordFilterList , hasFilterItems , totalCount , hasSolvookPassesFilter , sortList  } = param;
    // Tickets 타입의 필터만 타입이 다르기 때문에 label을 추가해 주었습니다.
    const addLabelTicketType = useMemo(()=>{
        if (!newFilterList || !selectedFilterList) return;
        return selectedFilterList.map((item)=>{
            const value = newFilterList[item.key];
            if (value && item.key === SearchQueryKey.TICKETS) {
                const findU = value === null || value === void 0 ? void 0 : value.find((ticket)=>String(ticket.id) === item.value);
                return {
                    ...item,
                    label: findU ? findU.value : ""
                };
            }
            if (item.key === SearchQueryKey.SOLVOOKPASSES) {
                return {
                    ...item,
                    label: SOLVOOKPASS_TEXT
                };
            }
            return item;
        });
    }, [
        newFilterList,
        selectedFilterList
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(ActiveTab, {
                tabList: subjectTabList,
                activeTab: filterParams.subject,
                setActiveTab: handleSubjectFilter
            }),
            /*#__PURE__*/ _jsx(SearchPageAdBanner, {
                position: "search",
                subject: filterParams.subject,
                mixpanelPosition: "handout"
            }),
            /*#__PURE__*/ _jsxs(FilterArea, {
                children: [
                    /*#__PURE__*/ _jsxs(SelectingArea, {
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "filter-area",
                                children: /*#__PURE__*/ _jsx(SearchDetailFilter, {
                                    handleSolvookPassesFilter: handleSolvookPassesFilter,
                                    onClickFilter: handleDetailFilter,
                                    filterList: newFilterList,
                                    hasSolvookPassesFilter: hasSolvookPassesFilter,
                                    isSolvookPassClicked: !!filterParams.filters.solvookPasses.length,
                                    isCheckFilterCount: isCheckFilterCount,
                                    isCheckFilterItem: isCheckFilterItem,
                                    handleMobileSlider: handleMobileSideSheet,
                                    hasFilterItems: hasFilterItems
                                })
                            }),
                            hasSelectedFilter && /*#__PURE__*/ _jsx(SearchFilterSelectedList, {
                                selectedFilterList: addLabelTicketType,
                                handleResetFilter: handleResetFilter,
                                handleDetailFilter: handleDetailFilter,
                                handleSolvookPassesFilter: handleSolvookPassesFilter,
                                hasSelectedFilter: hasSelectedFilter
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(SearchResultDesc, {
                        totalCount: totalCount,
                        sortList: sortList,
                        sort: filterParams.sort,
                        handleSortFilter: handleSortFilter
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(MobileSliderArea, {
                children: hasFilterItems && /*#__PURE__*/ _jsxs(MobileFilterSideSheet, {
                    title: "상세 필터",
                    openSlider: handleMobileSideSheet,
                    sliderOpen: mobileFilterSideSheet,
                    children: [
                        /*#__PURE__*/ _jsx(SearchFilterSelectedList, {
                            position: "sideSheet",
                            selectedFilterList: addLabelTicketType,
                            handleResetFilter: handleResetFilter,
                            handleDetailFilter: handleDetailFilter,
                            handleSolvookPassesFilter: handleSolvookPassesFilter,
                            hasSelectedFilter: hasSelectedFilter
                        }),
                        /*#__PURE__*/ _jsx(MobileSearchFilterItemList, {
                            newFilterList: newFilterList,
                            handleDetailFilter: handleDetailFilter,
                            selectedFilterList: selectedFilterList,
                            mobileFilterSideSheet: mobileFilterSideSheet,
                            handleMobileSideSheet: handleMobileSideSheet
                        })
                    ]
                })
            })
        ]
    });
};
